angular
    .module("home.directive")
    .directive("toolTip", function () {

        return function (scope, element, attrs) {

            var text = element.attr('qtip-content') || null,
                title = element.attr('qtip-title') || null;

            scope.qtipSkin = (attrs.skin ? "qtip-" + attrs.skin : "qtip-dark");

            $(element).qtip({
                content: {
                    text: text,
                    title: title
                },

                style: {
                    classes: "customToolTip",
                },
                show: {
                    event: 'mouseover',
                    solo: true
                },
                hide: {
                    event: (scope.closeButton == true ? "false" : "mouseleave"),
                    delay: 300,
                    fixed: (($(this).hover || attrs.fixed) ? true : false),  //prevent the tooltip from hiding when set to true
                    leave: true
                },
                position: {
                    viewport: $(window),// Keep it on-screen at all times if possible
                    target: (attrs.target ? attrs.target : "event"),
                    my: "left center",
                    at: "right center"
                }
            });

            scope.$on("$destroy", function () {
                $(element).qtip('destroy', true); // Immediately destroy all tooltips belonging to the selected elements
            });

            $('[tool-tip]').css("display", "inline-block");
        }
    })
    .directive('tooltipTable', function ($http, $compile, $templateCache) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var dataContent = element.attr('data-content') || null;
                $(element).qtip({
                    content: {
                        text: function (event, api) {
                            $.ajax({ url: dataContent })
                                .done(function (html) {
                                    api.set('content.text', html)
                                })
                                .fail(function (xhr, status, error) {
                                    api.set('content.text', status + ': ' + error)
                                })

                            return 'Loading...';
                        }
                    },
                    style: {
                        classes: "customToolTipTable",
                    },
                    show: {
                        event: 'mouseover',
                        solo: true
                    },
                    hide: {
                        event: (scope.closeButton == true ? "false" : "mouseleave"),
                        delay: 300,
                        fixed: (($(this).hover || attrs.fixed) ? true : false),  //prevent the tooltip from hiding when set to true
                        leave: true
                    },
                    position: {
                        viewport: $('.customToolTipTable'),// Keep it on-screen at all times if possible
                        target: (attrs.target ? attrs.target : "event"),
                        adjust: {
                            method: 'shift none'
                        },
                        my: "center",
                        at: "bottom center"
                    }
                });
                scope.$on("$destroy", function () {
                    $(element).qtip('destroy', true); // Immediately destroy all tooltips belonging to the selected elements
                });
            }
        }
    }) 